import React from "react";
// @material-ui/core components
import { useTheme } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";
import Menu from "@material-ui/core/Menu";
// @material-ui/icons components
import CreditCard from "@material-ui/icons/CreditCard";
import DateRange from "@material-ui/icons/DateRange";
import FileCopy from "@material-ui/icons/FileCopy";
import LocationOn from "@material-ui/icons/LocationOn";
import Mail from "@material-ui/icons/Mail";
import Report from "@material-ui/icons/Report";
import ShoppingBasket from "@material-ui/icons/ShoppingBasket";

// core components

const firstItems = [
  {
    name: "Calendar",
    icon: DateRange,
    color: "bgGradientError",
  },
  {
    name: "Email",
    icon: Mail,
    color: "bgGradientWarning",
  },
  {
    name: "Payments",
    icon: CreditCard,
    color: "bgGradientInfo",
  },
];

const secondItems = [
  {
    name: "Reports",
    icon: Report,
    color: "bgGradientSuccess",
  },
  {
    name: "Maps",
    icon: LocationOn,
    color: "bgGradientPurple",
  },
  {
    name: "Shop",
    icon: ShoppingBasket,
    color: "bgGradientYellow",
  },
];

export default function AppsDropdown() {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const isMenuOpen = Boolean(anchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const sxColors = {
    bgGradientError: {
      background:
        "linear-gradient(87deg," +
        theme.palette.error.main +
        ",#f56036)!important",
    },
    bgGradientWarning: {
      background:
        "linear-gradient(87deg," +
        theme.palette.warning.main +
        ",#fbb140)!important",
    },
    bgGradientInfo: {
      background:
        "linear-gradient(87deg," +
        theme.palette.info.main +
        ",#1171ef)!important",
    },
    bgGradientSuccess: {
      background:
        "linear-gradient(87deg," +
        theme.palette.success.main +
        ",#2dcecc)!important",
    },
    bgGradientPurple: {
      background: "linear-gradient(87deg,#8965e0,#bc65e0)!important",
    },
    bgGradientYellow: {
      background:
        "linear-gradient(87deg," +
        theme.palette.warning.light +
        ",#beff00)!important",
    },
  };

  const menuId = "dropdowns-apps-dropdown-id";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
      sx={{
        "& .MuiMenu-paper": {
          background: theme.palette.dark.main,
          minWidth: "320px",
        },
      }}
    >
      <Grid container sx={{ paddingLeft: "1.5rem", paddingRight: "1.5rem" }}>
        {firstItems.map((prop, key) => (
          <Grid
            item
            xs={4}
            key={key}
            sx={{
              paddingTop: "1rem",
              paddingBottom: "1rem",
              textAlign: "center",
            }}
          >
            <Avatar
              component="span"
              sx={{
                ...sxColors[prop.color],
              }}
            >
              <Box
                component={prop.icon}
                sx={{ width: "1.25rem!important", height: "1.25rem!important" }}
              />
            </Avatar>
            <Box
              component="small"
              sx={{
                display: "block",
                marginTop: ".75rem",
                fontSize: ".8125rem",
                fontWeight: "600",
              }}
            >
              {prop.name}
            </Box>
          </Grid>
        ))}
      </Grid>
      <Grid container sx={{ paddingLeft: "1.5rem", paddingRight: "1.5rem" }}>
        {secondItems.map((prop, key) => (
          <Grid
            item
            xs={4}
            key={key}
            sx={{
              paddingTop: "1rem",
              paddingBottom: "1rem",
              textAlign: "center",
            }}
          >
            <Avatar
              component="span"
              sx={{
                ...sxColors[prop.color],
              }}
            >
              <Box
                component={prop.icon}
                sx={{ width: "1.25rem!important", height: "1.25rem!important" }}
              />
            </Avatar>
            <Box
              component="small"
              sx={{
                display: "block",
                marginTop: ".75rem",
                fontSize: ".8125rem",
                fontWeight: "600",
              }}
            >
              {prop.name}
            </Box>
          </Grid>
        ))}
      </Grid>
    </Menu>
  );

  return (
    <>
      <IconButton
        aria-label="account of current user"
        aria-controls={menuId}
        aria-haspopup="true"
        onClick={handleProfileMenuOpen}
        sx={{
          "& .MuiIconButton-label": {
            fontSize: ".875rem",
            fontWeight: "600",
            color: theme.palette.buttonLightLabel.main,
            textTransform: "capitalize",
            display: "flex",
            alignItems: "center",
            [theme.breakpoints.down("md")]: {
              padding: "0!important",
            },
          },
        }}
      >
        <Box
          component={FileCopy}
          sx={{ width: "1rem!important", height: "1rem!important" }}
        />
      </IconButton>
      {renderMenu}
    </>
  );
}
